/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class UserCompanyDto {
  public id: string = undefined;
  public name: string = undefined;

  //<custom-body>
  constructor(source: UserCompanyDto) {
    this.id = source.id;
    this.name = source.name;
  }
  //</custom-body>
}
